import { yupResolver } from "@hookform/resolvers/yup";
import { Card, TextInput, Label, Button } from "flowbite-react"
import { useForm } from "react-hook-form";
import styled from "styled-components"
import { authSchema } from "../schemas/auth.schema";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { routes } from "../routes";
import { useAuth } from "../context/authContext";
import { useState } from "react";

const Background = styled.div`
    background-color: #d30c22;
    position:relative;
    display:flex;
    align-items:center;
    flex-direction:column;
    flex:1;
    width: 100%;
    height: 100vh;
    overflow: hidden;
`

const LoginScreen = () => {
    const navigate = useNavigate()
    const { singIn } = useAuth()
    const [loading, setLoading] = useState(false)

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(authSchema),
    });

    const submit = async (data: any) => {
        setLoading(true)
        try {
            if(!data.email || !data.password) return

            const didSignin = await singIn({
                email: data.email,
                password: data.password
            })

            if(!didSignin) {
                setLoading(false)
                toast("Usuario / Contraseña incorrectos, inténtelo de nuevo.", {
                    type: "error"
                })
                return
            }

            navigate(`${routes.DASHBOARD}/${routes.NOTES}`)

        } catch(e){
            setLoading(false)
        }
    }

    return <Background className="justify-center">
        <div className="items-center justify-center flex mb-4">
            <h1 className="text-5xl font-bold text-white" style={{
                fontFamily:"serif"
            }}>zocalo.monclova</h1>
        </div>
        <Card className="">
            <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
               Te damos la bienvenida
            </h5>
            <p className="font-normal text-gray-700 dark:text-gray-400">
                Por favor ingresa tus credenciales para continuar.
            </p>
            <div className="flex flex-col gap-4">
                <div>
                    <div className="mb-2 block">
                        <Label htmlFor="email" value="Email" />
                    </div>
                    <TextInput 
                        id="email"
                        placeholder="nombre@monclova.com"
                        type="email"
                        {...register("email")}
                        helperText={errors && errors.email ? errors.email?.message : ""}
                        color={errors && errors.email ? "failure" : "gray"}
                    />
                </div>
                <div>
                    <div className="mb-2 block">
                        <Label htmlFor="password" value="Contraseña" />
                    </div>
                    <TextInput 
                        id="password"
                        placeholder="••••••••"
                        type="password"
                        {...register("password")}
                        helperText={errors && errors.password ? errors.password?.message : ""}
                        color={errors && errors.password ? "failure" : "gray"}
                    />
                </div>
            </div>
            <Button isProcessing={loading} disabled={loading} onClick={handleSubmit(submit)} color={"failure"}>Iniciar sesión</Button>
        </Card>
    </Background>

}

export default LoginScreen